import { render, staticRenderFns } from "./PaymentLinks.vue?vue&type=template&id=5842481e&scoped=true&lang=true&"
import script from "./PaymentLinks.vue?vue&type=script&lang=js&"
export * from "./PaymentLinks.vue?vue&type=script&lang=js&"
import style0 from "./PaymentLinks.vue?vue&type=style&index=0&id=5842481e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5842481e",
  null
  
)

export default component.exports